import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import RichTextInput from 'components/RichTextInput';

import './styles/richText.scss';

const propTypes = {
    autoFocus: PropTypes.bool,
    fieldId: PropTypes.string,
    hidden: PropTypes.bool,
    hint: PropTypes.string,
    onChange: PropTypes.func,
    readOnly: PropTypes.bool,
    shouldRenderField: PropTypes.func,
    value: PropTypes.shape({
        html: PropTypes.string,
        text: PropTypes.string,
    }),
};

const RichText = memo(
    ({ autoFocus, fieldId, hidden, hint, onChange, readOnly, shouldRenderField, value = {} }) => {
        const [innerValue, setInnerValue] = useState(value);
        const prevValue = useRef(value);

        // ========================================
        // EFFECTS
        // ========================================
        useEffect(() => {
            if (prevValue.current !== value) {
                setInnerValue(value);
            }
            prevValue.current = value;
        }, [value]);

        // ========================================
        // EVENT HANDLERS & CALLBACKS
        // ========================================
        const handleChange = useCallback(
            (newValue) => {
                setInnerValue(newValue);
                onChange?.(newValue);
            },
            [onChange],
        );

        // ========================================
        // RENDER
        // ========================================
        if (hidden) return null;
        if (shouldRenderField && !shouldRenderField(fieldId)) return null;

        return (
            <div className="fm-field-richtext">
                <RichTextInput
                    autoFocus={autoFocus}
                    defaultValue={innerValue?.html || innerValue?.text || ''}
                    hint={hint}
                    isReadOnly={readOnly}
                    onChange={handleChange}
                />
            </div>
        );
    },
);

RichText.displayName = 'RichText';
RichText.propTypes = propTypes;

export default RichText;
